import { noop } from 'lodash';
import React, { useContext, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  DetailContext,
  DictionaryEvidence,
  FormPanel,
  FormTextArea,
  TreeBuilder,
} from '@eas/common-web';
import { useCommonHistoryDescriptors } from '@composite/history/history-common-descriptors';
import { HistoryField } from '@composite/history/history-field';
import { useSubjectIndexesTree } from './dict-subject-index-api';

export function Fields() {
  const historyDescriptors = useCommonHistoryDescriptors();

  const { source } = useContext(DetailContext);

  const subTree = useSubjectIndexesTree({
    rootId: source.data?.id,
  });

  useEffect(() => {
    subTree.setSearchQuery('');
    subTree.reset(source.data?.id);
    subTree.loadMore();
  }, [source.data?.id]);

  return (
    <>
      <FormPanel
        label={
          <FormattedMessage
            id="ES__DICT_SUBJECT_INDEX__DETAIL__PANEL_TITLE__GENERAL"
            defaultMessage="Obecné"
          />
        }
        expandable={false}
      >
        <FormTextArea
          name="name"
          required
          label={
            <FormattedMessage
              id="ES__DICT_SUBJECT_INDEX__DETAIL__FIELD_LABEL__NAME"
              defaultMessage="Název"
            />
          }
        />
        <DictionaryEvidence.FieldActive />
      </FormPanel>
      <TreeBuilder source={subTree} value={[]} onChange={noop} />
      <HistoryField
        descriptors={[
          ...historyDescriptors,
          { key: 'parent', label: 'Nadřazený prvek' },
          { key: 'children', label: 'Podřazené prvky' },
          { key: 'childrenCount', label: 'Počet potomků' },
          { key: 'level', label: 'Úroveň zanoření' },
          { key: 'hierarchicalOrder', label: 'Hierachické pořadí' },
        ]}
      />
    </>
  );
}
